// Libs
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IntercomAPI } from "react-intercom";
import PropTypes from "prop-types";

// Components
import Plans from "../../Plans";

// Actions
import { trackPaywallView } from "../../../actions/tracker";

class PlansTab extends React.Component {
  static propTypes = {
    location: PropTypes.object
  };

  componentDidMount() {
    IntercomAPI("trackEvent", "Visit: Plans page");
    document.title = "Settings - Plans - Spocket";
    this.props.trackPaywallView(
      "settings_plan",
      "plan",
      null,
      null,
      null,
      "viewed_all_plans"
    );
  }

  render() {
    return (
      <div>
        <h5 className="settings__subtitle header-tip">Pricing Plans</h5>
        <hr />
        <Plans location={this.props.location} />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ trackPaywallView }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(PlansTab);



// WEBPACK FOOTER //
// ./src/components/Settings/PlansTab/index.js